import { type ApiClient, listQueryParams } from "./client";
import type { ConversationDetail, ConversationFilters, ConversationRow, ListQuery, Message, Page, TimelineEvent } from "./types";

/** Conversations: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface ConversationsApi {
  list(query: ListQuery<ConversationFilters>): Promise<Page<ConversationRow>>;
  get(id: string): Promise<ConversationDetail>;
  messages(id: string): Promise<Message[]>;
  timeline(id: string): Promise<TimelineEvent[]>;
  /** A photo of a message: a short-lived URL the browser can load. */
  media(messageId: string, index: number): Promise<{ url: string; contentType: string }>;
}

export function createHttpConversationsApi(client: ApiClient): ConversationsApi {
  return {
    list: (q) => client.call("listConversations", { query: listQueryParams(q) }),
    get: (id) => client.call("getConversation", { params: { id } }),
    messages: async (id) => (await client.call<{ items: Message[] }>("listConversationMessages", { params: { id } })).items,
    timeline: async (id) => (await client.call<{ items: TimelineEvent[] }>("getConversationTimeline", { params: { id } })).items,
    media: (messageId, index) => client.call("getMessageMedia", { params: { id: messageId, index: String(index) } }),
  };
}
